import { useApiPost } from '@/api/main/query'
import { deviceAPI } from '@/features/devices/api/endpoints'
import { NewDeviceModel } from '@/features/devices/types/types'
import PlusIcon from '@/shared/assets/icons/plusIcon.svg?react'
import { BaseDialog, BaseInput } from '@/shared/components'
import { DEFAULT_TAKE } from '@/shared/constants/constants'
import { useToast } from '@/shared/hooks'
import { useQueryClient } from '@tanstack/react-query'
import { SubmitHandler, useForm } from 'react-hook-form'

type Props = {
  modalVisible: boolean
  setModalVisible: (value: boolean) => void
}

export const AddNewDevice = ({ modalVisible, setModalVisible }: Props) => {
  const { addToast } = useToast()

  const qc = useQueryClient()
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<{ deviceName: string }>()

  const { mutate: create, isPending } = useApiPost<{ value: NewDeviceModel }, { name: string }>(
    deviceAPI.create
  )

  const onSubmit: SubmitHandler<{ deviceName: string }> = (data) => {
    console.log(data.deviceName, 'device name')
    create(
      { name: data.deviceName },
      {
        onSuccess: () => {
          addToast('Успех!', 'Устройство создано', 'success')
          setModalVisible(false)

          reset()

          qc.invalidateQueries({
            queryKey: ['devices', 0, DEFAULT_TAKE, '', 0],
          })
        },
        onError: (error) => {
          addToast('Ошибка!', error.message, 'error')
        },
      }
    )
  }

  return (
    <BaseDialog
      isVisible={modalVisible}
      onClose={() => setModalVisible(false)}
      onAction={handleSubmit(onSubmit)}
      actionButtonName="Добавить"
      xButton={false}
      iconTitle={<PlusIcon className="text-[var(--status-purple-fill)]" />}
      isLoading={isPending}
    >
      <div className="flex flex-col gap-6">
        <p className="text-[20px]">Добавление нового устройства</p>
        <form onSubmit={handleSubmit(onSubmit)} className="w-full">
          <BaseInput
            label="Название устройства"
            variant="secondary"
            className="text-sm"
            placeholder="Придумайте название для устройства"
            {...register('deviceName', {
              required: 'Поле обязательно',
              minLength: { value: 2, message: 'Мин. 2 символа' },
            })}
            error={errors.deviceName?.message}
          />
        </form>
      </div>
    </BaseDialog>
  )
}
